import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import {
  ILead,
  GetLeadByIdQuery,
  ILeadInput,
  LEAD_MUTATION,

} from '@ebb-v2/ebb-integration';

import { Apollo } from 'apollo-angular';
import {

} from '@ebb-v2/ebb-integration';
import { LeadApiService } from '../lead-api.service';

@Injectable({
  providedIn: 'root'
})
export class LeadGqlService implements LeadApiService {
  currentUser: Observable<ILead>;

  constructor(private apollo: Apollo) {}

  public getLead(id: string): Observable<ILead> {
    console.log(`LeadtGql.getLead()`);
    return this.apollo
      .watchQuery({
        query: GetLeadByIdQuery,
        variables: {
          id: id
        }
      })
      .valueChanges.pipe(
        map(result => result.data['lead'] as ILead),
        take(1)
      );
  }


  public saveLead(lead: ILeadInput): any {
    console.log(`LeadGql.saveLead()`);

    return new Observable((observer) => {
      this.apollo.mutate({
        mutation: LEAD_MUTATION,
        variables: {
          lead: lead
        }
      }).subscribe(response => {
        if (response.errors && response.errors[0]) {
          observer.error('Error:' + response.errors[0].message);
          return;
        }
        const returndata = response.data['saveLead'] as ILead;
        observer.next(returndata);
        observer.complete();
      });
    });

  }
}
